module.exports = __webpack_public_path__ + "static/media/retirement-object-3-0-0.e7fcb316.png";